import React, {useEffect} from 'react'
import {LangButton} from './LangButton'
import {textStrings as txt} from './textStrings'
import Dropdown from './Dropdown'
import SideNav from './SideNav'
import Modal from './Modal'
import {useStore} from 'react-hookstore'
/** 
   TopNav is fixed at the top of the page, so it acts an an anchor to
   Components that don't scroll with the rest of the page content.  It
   has a dual purpose, one being a navbar displayed at the top of the
   page, and the other anchoring dropdown menus, as provided by
   its child component Dropdown with parameters and children.  
 */
function TopNav() {
  const [lang] = useStore('language')
  const [sidebar, setSidebar] = useStore('sidebar')
  const openSideBar = () => {
    document.body.style.overflow = 'hidden'
    setSidebar({
      open: true,
      body: <SideNav/>
    })
  }
  const closeSideBar = () => {
    document.body.style.overflow = 'auto'
    setSidebar({
      open: false,
      body: <></>
    })
  }
  const toggleSideBar = () => {
    sidebar.open === true? closeSideBar() : openSideBar()
  }

  useEffect(() => {
    // Give topNav some opacity when scrolled down past 30px.
    window.addEventListener('scroll', () => {
      if (window.scrollY > 30) {
        document.getElementsByClassName('topNav')[0].className = 'topNav opaque'
      } else {
        document.getElementsByClassName('topNav')[0].className = 'topNav'
      }
    })
  },[])

  return (
    <nav className='topNav'>
      {/* Horizontal menu, starting with the hamburger 'button'. */}
      <ul>
        <li className='burger dropbtn' key='menu' onClick={toggleSideBar}>
          ☰&nbsp;
        </li>
        <li key='times'>
          {/* Dropdown children invoke modals on selection. */}
          <Dropdown name={txt.masstimes[lang]} key='masstimes'>
            <content>sundaymass</content>
            <content>weekdaymass</content>
          </Dropdown>
        </li>
        <li key='about'>
          <Dropdown name={txt.aboutUs[lang]} key='aboutUs'>
            <content>about</content>
            <content>aboutLeo</content>
          </Dropdown>
        </li>
        <li key='LangButton'>
          <LangButton />
        </li>
      </ul>
      {/* SideNav menubar is empty until invoked. */}
      {sidebar.body}
      {/* Hidden until invoked. Modal is here for display fixed anchor point. */}
      <Modal />
    </nav>
  )
}
export default TopNav
